exports = module.exports = require("../../../node_modules/.pnpm/css-loader@0.28.11/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vue-onboarding__actions{padding:0 16px 16px}.vue-onboarding__actions .vue-onboarding__actions__prev{color:#6c757d!important;border-color:#6c757d!important}.vue-onboarding__actions_per_page{padding:0 16px 16px;background:#da2d8a;border-radius:0 0 6px 6px;border-left:1px solid #f3f2f7;border-right:1px solid #f3f2f7;border-bottom:1px solid #f3f2f7}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/.pnpm/css-loader@0.28.11/node_modules/css-loader?minimize!./node_modules/.pnpm/vue-loader@13.7.3_babel-core@6.26.3_css-loader@0.28.11_lodash@4.18.1_vue-template-compiler@2.7.16_webpack@3.12.0/node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7b5587b4","scoped":false,"hasInlineConfig":false}!./node_modules/.pnpm/sass-loader@7.3.1_webpack@3.12.0/node_modules/sass-loader/dist/cjs.js!./node_modules/.pnpm/vue-loader@13.7.3_babel-core@6.26.3_css-loader@0.28.11_lodash@4.18.1_vue-template-compiler@2.7.16_webpack@3.12.0/node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/VueOnboarding/VueOnboardingActions.vue
// module id = H2o4
// module chunks = 45